let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eX2ga")).then(() => parcelRequire('lBy6e'));